import { AuthService } from '@1bill-app/services/auth/state/auth.service';
import { BillQuery } from '@1bill-app/services/bill/bill.query';
import { HomeQuery } from '@1bill-app/services/home/home.query';
import { HomeService } from '@1bill-app/services/home/home.service';
import { SettingsQuery } from '@1bill-app/services/settings/settings.query';
import { SettingsService } from '@1bill-app/services/settings/settings.service';
import { Settings } from '@1bill-app/services/settings/settings.store';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { KeyboardInfo, Keyboard } from '@capacitor/keyboard';
import {
  IonFab,
  IonTabs,
  MenuController,
  NavController,
  Platform,
  PopoverController,
  ToastController,
} from '@ionic/angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NGXLogger } from 'ngx-logger';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import {
  ROUTE_CONNECT_EMAIL,
  ROUTE_EMAIL_BILLS,
  ROUTE_EMAIL_SCANNER,
  ROUTE_EMAIL_SCANNER_JOBS,
  ROUTE_HOMEPAGE,
  ROUTE_UPLOAD_YOUR_BILL,
  ROUTE_OFFERS,
  SEND_VIA_EMAIL_TITLE,
  ROUTE_BILLS_PAGE,
  ROUTE_HELP,
  ROUTE_TERMS,
  MOBILE_VIEW_THRESHOLD_PX,
  ROUTE_ADD_BILL_MANUALLY,
} from '@1bill-app/constants';
import { ADD_BILL_MENU } from 'src/app/app.menu';
import { SubSink } from 'subsink';
import '../../helpers/string.helper';
import { TabHomePage } from '../tab-home/tab-home.page';
import { TabsMorePopoverComponent } from './tabs-more.popover.component';
import { UserService } from '@1bill-app/services/user/user.service';
import { UserQuery } from '@1bill-app/services/user/user.query';
import { Clipboard } from '@capacitor/clipboard';
import { AuthQuery } from '@1bill-app/services/auth/state/auth.query';
/**
 * Parent page for displaying tabs in home page.
 */
@UntilDestroy()
@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss'],
})
export class TabsPage implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(IonTabs) tabs: IonTabs;
  @ViewChild(TabHomePage) homePage: TabHomePage;
  @ViewChild('moreButton', { static: false }) moreButton;

  subs = new SubSink();
  selectedTab: any;
  accountSettings: Settings;
  billEmailAddress: string;
  mediaType = MEDIA_TYPE;
  keyboardShown = false;
  sendViaEmamilTitle = SEND_VIA_EMAIL_TITLE;
  isActivated$: EventEmitter<boolean> = new EventEmitter();

  addBillMenu = ADD_BILL_MENU;
  hideButtonList = true;
  hideSendEmailInfo = true;

  //FAB - Add Bills
  @ViewChild(IonFab) fab: IonFab;
  @ViewChild('fabOverlay', { static: false }) fabOverlay: ElementRef;

  fabObserver: MutationObserver;

  isLoggedIn: boolean;

  directEmail: any;
  public user$ = this.userQuery.select('user');

  readonly routeHomepage = ROUTE_HOMEPAGE;
  readonly routeBills = ROUTE_BILLS_PAGE;
  readonly routeUploadYourBill = ROUTE_UPLOAD_YOUR_BILL;
  readonly routeOffers = ROUTE_OFFERS;
  readonly routeHelp = ROUTE_HELP;
  readonly routeEnterBillManually = ROUTE_ADD_BILL_MANUALLY;

  emailScannedBillsToVerify$ = this.billQuery.emailScannedBillsToVerify$;
  // FEATURE_FLAG: DISABLE_LINK_ACCOUNT
  disableConnectAcBtn$ = this.homeQuery.select('featureFlags').pipe(
    map((flags) => {
      if (flags?.length) {
        if (flags.indexOf('DISABLE_LINK_ACCOUNT') >= 0) {
          return true;
        }
      }
      return false;
    }),
  );

  activatedTabRoute: string;
  terms = ROUTE_TERMS;
  event: any;

  constructor(
    private popoverCtrl: PopoverController,
    private logger: NGXLogger,
    private homeQuery: HomeQuery,
    private homeService: HomeService,
    private menu: MenuController,
    private settingsQuery: SettingsQuery,
    private _settings: SettingsService,
    private navCtrl: NavController,
    public platform: Platform,
    private elementRef: ElementRef,
    private router: Router,
    private billQuery: BillQuery,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private route: ActivatedRoute,
    private toastCtrl: ToastController,
    private userQuery: UserQuery,
    private userSvc: UserService,
    private renderer: Renderer2,
    private authQuery: AuthQuery,
  ) {
    this.isLoggedIn = this.authQuery.isLoggedIn;

    this.billQuery.showAppMenu.subscribe((value) => {
      if (value) {
        this.middleTabHandler();
      }
    });
  }

  get isDesktopView() {
    return this.platform.width() >= MOBILE_VIEW_THRESHOLD_PX;
  }

  get userCanAddBills() {
    return this.userQuery.userCanAddBills;
  }

  async ngOnInit() {
    const { directEmail } = this.route.snapshot.queryParams;
    this.directEmail = directEmail;
    this.logger.log('directEmail', this.directEmail);
    this.userSvc.getUser().subscribe();
    // if (this.platform.is('ios')){
    //   ZohoSalesIQ.init("%2BbuIHJMMHWl%2Fv72j1lNmTP3NvqwR729uwoQJ1mKV%2BOOKmiLbq2lH8w%3D%3D_au", "C2cd%2FbsjqpCPRYoGK3rGG%2FuI4gFDJONIrAvcBJOQxC1fFXm5k6Sh9mJNXq%2F8iBa3ZXukttDUUwl3DCjCvUopD8ppKYdETrsWYlaIeO4PEjQ%3D", (success)=>{
    //     console.log('success ZohoSalesIQ',success);

    //   }, (error)=>{
    //     console.error('error ZohoSalesIQ', error)
    //   });
    // }else{
    //   ZohoSalesIQ.init("android_app_key", "android_access_key");
    // }
    // ZohoSalesIQ.showLauncher(false);

    this.keyboardEventListener();

    this.homeService.addBillEvent$.subscribe(() => {
      this.updateContentOverlay();
      if (this.fab) this.fab.activated = true;
    });

    this.observeFabMutation();
    this.subs.sink = this.isActivated$.pipe(distinctUntilChanged()).subscribe(() => {
      this.updateContentOverlay();
    });

    const loggedIn = await this.authService
      .isAuthenticated()
      .toPromise()
      .then((user) => user.loggedIn);

    if (loggedIn) {
      this.subs.sink = this._settings.fetch().subscribe({
        next: () => {
          // this.logger.log('user settings data fetched:', JSON.stringify(r));
          this.logger.log('dismiss loading controller');
        },
        error: (e) => {
          this.logger.error('unable to fetch user settings data', e);
        },
      });
    }

    this.settingsQuery.select().subscribe({
      next: (data) => {
        this.accountSettings = data;
        this.billEmailAddress = this.accountSettings.billEmail;
        this.logger.debug('Settings data', this.accountSettings);
      },
      error: (err) => {
        this.logger.error('unable to retrieve user setting from data store', err);
      },
    });

    // Set initially, as when loading the page, it is not an event sent through `this.router.events`
    this.activatedTabRoute = this.router.url;

    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.hideButtonList = true;
        this.activatedTabRoute = event.url;
      });
  }

  ngAfterViewInit() {
    this.initResizeListener();
    this.updateSafeAreaBottom();
    this.updateTabBarHeight(this.platform.width());
  }

  middleTabHandler() {
    this.updateContentOverlay();
    // this.hideButtonList = !this.hideButtonList;
  }

  ngOnDestroy() {
    if (this.fab) this.fabObserver.disconnect();
    this.subs.unsubscribe();
  }

  ionViewDidEnter() {
    this.closeFab();
  }

  sendEmailInfoHandler() {
    this.hideButtonList = true;
    this.hideSendEmailInfo = false;
    //this.emailBill();
  }

  backdropClickHandler() {
    this.hideButtonList = true;
    //this.hideSendEmailInfo = true;
  }

  sendEmailInfoBgClickHandler() {
    this.hideSendEmailInfo = true;
  }

  /**
   * Keyboard enent listeners for display/hide fab button.
   * TODO: fix flicker issue during keyboardWillHide event.
   */
  private keyboardEventListener() {
    if (Capacitor.isNativePlatform()) {
      Keyboard.addListener('keyboardWillShow', (info: KeyboardInfo) => {
        this.logger.debug('keyboardWillShow', info);
        this.keyboardShown = true;
        this.cdr.detectChanges();
      });
      Keyboard.addListener('keyboardWillHide', () => {
        setTimeout(() => {
          this.keyboardShown = false;
          this.logger.debug('keyboardWillHide');
          this.cdr.detectChanges();
        }, 50);
      });
    }
  }

  async copyToClipboard(value: string) {
    await Clipboard.write({ string: value });
    const toast = await this.toastCtrl.create({
      message: 'Copied to clipboard',
      duration: 2000,
    });
    toast.present();
  }

  onHomeClick() {
    if (this.router.url === ROUTE_HOMEPAGE) {
      this.homeService.scrollToTop(true, 'TabsPage');
    }
    this.closeFab();
  }

  async presentMorePopover(ev: any) {
    const popover = await this.popoverCtrl.create({
      component: TabsMorePopoverComponent,
      cssClass: 'my-custom-class',
      event: ev,
      translucent: true,
    });
    return await popover.present();
  }
  // gotoSettingsPage() {
  //   this.router.navigateByUrl('/app/settings');
  // }
  // TODO: use upload-common service

  openMenu() {
    // this.menu.enable(true, 'main-menu');
    this.menu.open('main-menu');
  }

  async updateContentOverlay() {
    if (!this.isDesktopView) {
      this.hideButtonList = !this.hideButtonList;
      return;
    }

    const el: Element = this.fabOverlay?.nativeElement;
    if (!el) return;
    if (this.fab.activated) {
      el.classList.add('fab-backdrop');
    } else {
      this.closeFab();
    }
  }

  closeFab() {
    // Only proceed if on desktop view. "Add Bills" Fab is not present on smaller screens.
    if (!this.isDesktopView) return;

    const el: Element = this.fabOverlay.nativeElement;
    this.fab.activated = false;
    if (el.classList.contains('fab-backdrop')) {
      el.classList.remove('fab-backdrop');
    }
  }

  observeFabMutation() {
    try {
      // Only proceed if on desktop view. "Add Bills" Fab is not present on smaller screens.
      if (!this.isDesktopView) return;

      // Select the node that will be observed for mutations
      const targetNode = document.getElementById('tabs-ion-fab-list');

      // Create an observer instance
      this.fabObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if ((mutation.target as any).id == 'tabs-ion-fab-list') {
            const isActivated = (document.getElementById('tabs-ion-fab') as any).activated;
            if (typeof isActivated === 'boolean') {
              this.isActivated$.emit(isActivated);
            }
          }
        });
      });

      // Start observing the target node for configured mutations
      if (targetNode) {
        this.fabObserver.observe(targetNode, {
          attributes: true,
          childList: false,
          subtree: false,
        });
      }
    } catch (error) {
      this.logger.error('observeFabMutation', error);
    }
  }

  updateSafeAreaBottom() {
    const safeAreaButton = getComputedStyle(document.documentElement).getPropertyValue(
      '--ion-safe-area-bottom',
    );
    this.logger.debug('safeAreaButton', safeAreaButton);

    if (safeAreaButton.extractNumber() > 15) {
      const elements: HTMLElement[] = [];
      elements.push((this.tabs.tabBar as any).el as HTMLElement);
      elements.push(document.querySelector('#tabs-ion-fab'));

      elements
        .filter((el) => !!el)
        .forEach((el) => {
          el.style.setProperty('--ion-safe-area-bottom', '15px');
        });
    }
  }

  async uploadYourBill(mediaType: MEDIA_TYPE) {
    if (mediaType === MEDIA_TYPE.PDF_FILE || mediaType === MEDIA_TYPE.IMG_FILE) {
      this.navCtrl.navigateForward([ROUTE_UPLOAD_YOUR_BILL, mediaType]);
      // if (this.platform.is('ios')){
      //   const modal = await this.modalController.create({
      //     component: UploadYourBillPage,
      //     cssClass: 'my-custom-class',
      //     swipeToClose: true,
      //     presentingElement: this.routerOutlet.nativeEl,
      //     componentProps: {
      //       mediaTypeModal: mediaType
      //     }
      //   });
      //   return await modal.present();
      // }else{
      //   this.navCtrl.navigateForward([ROUTE_UPLOAD_YOUR_BILL, mediaType]);
      // }
    }
  }

  initResizeListener() {
    fromEvent(window, 'resize')
      .pipe(debounceTime(300), untilDestroyed(this))
      .subscribe((event) => {
        const el = event.target as Window;
        this.updateTabBarHeight(el.innerWidth);
      });
  }

  updateTabBarHeight(windowWidth: number) {
    if (!this.userCanAddBills) return;
    const el = this.elementRef.nativeElement as HTMLElement;
    el.style.setProperty(
      '--tab-bar-height',
      windowWidth < MOBILE_VIEW_THRESHOLD_PX ? '70px' : '0px',
    );

    // Only proceed if on desktop view. "Add Bills" Fab is not present on smaller screens.
    if (!this.isDesktopView) return;

    const fabEl = (this.fab as any).el as HTMLElement;
    if (windowWidth < MOBILE_VIEW_THRESHOLD_PX) {
      fabEl.classList.remove('tab-bar-hidden');
      fabEl.classList.add('tab-bar-visible');
      this.renderer.setAttribute(fabEl, 'horizontal', 'center');
    } else {
      fabEl.classList.remove('tab-bar-visible');
      fabEl.classList.add('tab-bar-hidden');
      this.renderer.setAttribute(fabEl, 'horizontal', 'end');
    }
  }

  connectEmail() {
    this.navCtrl.navigateForward([ROUTE_CONNECT_EMAIL]);
  }

  emailScannerBillList() {
    this.navCtrl.navigateForward([ROUTE_EMAIL_SCANNER_JOBS]);
  }

  emailScannerPage() {
    this.navCtrl.navigateForward([ROUTE_EMAIL_SCANNER]);
  }

  emailBill() {
    this.navCtrl.navigateForward([ROUTE_EMAIL_BILLS]);
  }

  loggedIn() {
    if (this.isLoggedIn === false) {
      return false;
    } else {
      return true;
    }
  }
  async chat() {
    return this.authService.openZohoChat();
  }
}

export enum MEDIA_TYPE {
  PDF_FILE = 'pdf',
  IMG_FILE = 'img',
}
